import { Storage, Drivers } from '@ionic/storage';
import { useEffect, useState } from 'react';

const TOKEN_KEY = 'token';
const DATABSE_NAME = 'gs-app';

export function useTokenStorage() {
  const [storage, setStorage] = useState<Storage>();
  const [storedToken, setStoredToken] = useState<string | null>();

  const initStorage = async () => {
    const newStore = new Storage({
      name: DATABSE_NAME,
      driverOrder: [
        Drivers.SecureStorage,
        Drivers.IndexedDB,
        Drivers.LocalStorage
      ]
    });

    const store: any = await newStore.create();
    setStorage(store);

    const token: any = await store.get(TOKEN_KEY);
    setStoredToken(token);

    return storage;
  }

  useEffect(() => {
    initStorage();
  }, []);

  const storeToken = async (token: string | null) => {
    initStorage();

    // Temporary workaround for classes that cannot use this hook
    //
    // await window.localStorage.setItem('token', (token || ''));

    storage?.set(TOKEN_KEY, token);
    setStoredToken(token);
    window.localStorage.setItem('token', (token || ''));

    return storedToken;
  }

  return {
    storedToken,
    setStoredToken,
    storeToken
  }
}

export default useTokenStorage;